<template>
  <div class="xv_view" id="Health_declaration">
    <div class="xv_top">
      <div>
        <label class="xv_view_title">Health declaration</label>
      </div>
      <div class="xv_actions"></div>
    </div>
    <div class="xv_table">
      <div class="xv_table_title">
        <div>
          <span>Declarations (5) for this week</span>
        </div>
        <div>
          <button class="sec_btn" @click="table_filter_hd()">
            Filter
            <span class="mdi mdi-filter-menu"></span>
          </button>
        </div>
      </div>

      <div class="filter_wrap">
        <div class="left_filter" v-if="left_filter_hd == true">
          <div class="header_section top">
            <div>
              <span class="main_title">
                Filter
                <span class="mdi mdi-filter-menu"></span>
              </span>
            </div>
            <div>
              <span class="option">Reset</span>
            </div>
          </div>
          <div class="section">
            <div class="header_section">
              <div>
                <span class="title">Date</span>
              </div>
              <div>
                <span class="option">Clear</span>
              </div>
            </div>

            <div class="content">
              <div class="xv_datepicker">
                <span class="mdi mdi-calendar-month"></span>
                <vc-date-picker
                  mode="range"
                  v-model="selectedDate"
                  :popover="{ visibility: 'click' }"
                  :input-props="{
                    class: 'picker_input',
                    placeholder: 'Select dates',
                    readonly: true
                  }"
                  :masks="{ input: 'DD/MM/YY' }"
                />
              </div>
            </div>
          </div>
          <div class="section">
            <div class="header_section">
              <div>
                <span class="title">Status</span>
              </div>
              <div>
                <span class="option">Clear</span>
              </div>
            </div>

            <div class="content">
              <div class="filter_checkbox">
                <div class="check">
                  <b-form-checkbox id="checkbox-1" name="checkbox-1"></b-form-checkbox>
                </div>
                <div class="check_label">
                  <span>Pending</span>
                </div>
              </div>

              <div class="filter_checkbox">
                <div class="check">
                  <b-form-checkbox id="checkbox-3" name="checkbox-3"></b-form-checkbox>
                </div>
                <div>
                  <span class="check_label">Completed</span>
                </div>
              </div>
            </div>
          </div>
          <div class="section">
            <div class="header_section">
              <div>
                <span class="title">Health</span>
              </div>
              <div>
                <span class="option">Clear</span>
              </div>
            </div>

            <div class="content">
              <div class="filter_checkbox">
                <div class="check">
                  <b-form-checkbox id="checkbox-1" name="checkbox-1"></b-form-checkbox>
                </div>
                <div class="check_label">
                  <span>Ok</span>
                </div>
              </div>

              <div class="filter_checkbox">
                <div class="check">
                  <b-form-checkbox id="checkbox-3" name="checkbox-3"></b-form-checkbox>
                </div>
                <div>
                  <span class="check_label">Diagnosed</span>
                </div>
              </div>
              <div class="filter_checkbox">
                <div class="check">
                  <b-form-checkbox id="checkbox-4" name="checkbox-4"></b-form-checkbox>
                </div>
                <div>
                  <span class="check_label">Suspect</span>
                </div>
              </div>
            </div>
          </div>

          <div class="section">
            <div class="header_section">
              <div>
                <span class="title">Travel History</span>
              </div>
              <div>
                <span class="option">Clear</span>
              </div>
            </div>

            <div class="content">
              <div class="filter_checkbox">
                <div class="check">
                  <b-form-checkbox id="checkbox-5" name="checkbox-5"></b-form-checkbox>
                </div>
                <div>
                  <span class="check_label">Ok</span>
                </div>
              </div>
            </div>
            <div class="content">
              <div class="filter_checkbox">
                <div class="check">
                  <b-form-checkbox id="checkbox-5" name="checkbox-5"></b-form-checkbox>
                </div>
                <div>
                  <span class="check_label">Violation</span>
                </div>
              </div>
            </div>
          </div>

          <div class="section">
            <div class="header_section">
              <div>
                <span class="title">Quaratine</span>
              </div>
              <div>
                <span class="option">Clear</span>
              </div>
            </div>

            <div class="content">
              <div class="filter_checkbox">
                <div class="check">
                  <b-form-checkbox id="checkbox-5" name="checkbox-5"></b-form-checkbox>
                </div>
                <div>
                  <span class="check_label">Ok</span>
                </div>
              </div>
            </div>
            <div class="content">
              <div class="filter_checkbox">
                <div class="check">
                  <b-form-checkbox id="checkbox-5" name="checkbox-5"></b-form-checkbox>
                </div>
                <div>
                  <span class="check_label">Quaratine</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <table class="health_declaration_table">
          <thead>
            <tr>
              <th style>Name</th>
              <th style="text-align:center">Date</th>
              <th style="text-align:center">Temperature</th>
              <th style="text-align:center">Symptoms</th>
              <th style="text-align:center;width:14%">Travel History</th>
              <th style="text-align:center;width:14%">Quaratine</th>
              <th style="text-align:center;width:7%">View</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Joseph Davis</td>
              <td>
                <span>02-Jan-2020 10:30am</span>
              </td>
              <td>
                <span class="mdi mdi-thermometer"></span> 34.3
              </td>
              <td>Fever, Cough</td>
              <td class="modify">
                <select name id>
                  <option value>Ok</option>
                  <option value>Block</option>
                </select>
              </td>
              <td class="modify">
                <select name id>
                  <option value>Ok</option>
                  <option value>Block</option>
                </select>
              </td>
              <td>
                <span class="mdi mdi-clipboard-text-outline" @click="view_declaration"></span>
              </td>
            </tr>

            <tr>
              <td>Jasmine Morgan</td>
              <td>
                <span>02-Jan-2020 10:30am</span>
              </td>
              <td>
                <span class="mdi mdi-thermometer"></span> 34.0
              </td>
              <td>Cough</td>
              <td class="modify">
                <select name id>
                  <option value>Ok</option>
                  <option value>Block</option>
                </select>
              </td>
              <td class="modify">
                <select name id>
                  <option value>Ok</option>
                  <option value>Block</option>
                </select>
              </td>
              <td>
                <span class="mdi mdi-clipboard-text-outline" @click="view_declaration"></span>
              </td>
            </tr>

            <tr>
              <td>Anthony Cook</td>
              <td>
                <span>02-Jan-2020 10:30am</span>
              </td>
              <td>
                <span class="mdi mdi-thermometer"></span> 35.2
              </td>
              <td>Fever</td>
              <td class="modify">
                <select name id>
                  <option value>Ok</option>
                  <option value>Block</option>
                </select>
              </td>
              <td class="modify">
                <select name id>
                  <option value>Ok</option>
                  <option value>Block</option>
                </select>
              </td>
              <td>
                <span class="mdi mdi-clipboard-text-outline" @click="view_declaration"></span>
              </td>
            </tr>

            <tr>
              <td>Ellis Morrow</td>
              <td>
                <span>02-Jan-2020 10:30am</span>
              </td>
              <td>
                <span class="mdi mdi-thermometer"></span> 33.7
              </td>
              <td>Fever, Sore throat</td>
              <td class="modify">
                <select name id>
                  <option value>Ok</option>
                  <option value>Block</option>
                </select>
              </td>
              <td class="modify">
                <select name id>
                  <option value>Ok</option>
                  <option value>Block</option>
                </select>
              </td>
              <td>
                <span class="mdi mdi-clipboard-text-outline" @click="view_declaration"></span>
              </td>
            </tr>

            <tr>
              <td>Yasmine Hoffman</td>
              <td>
                <span>02-Jan-2020 10:30am</span>
              </td>
              <td>
                <span class="mdi mdi-thermometer"></span> 35.0
              </td>
              <td>Fever, Cough</td>
              <td class="modify">
                <select name id>
                  <option value>Ok</option>
                  <option value>Block</option>
                </select>
              </td>
              <td class="modify">
                <select name id>
                  <option value>Ok</option>
                  <option value>Block</option>
                </select>
              </td>
              <td>
                <span class="mdi mdi-clipboard-text-outline" @click="view_declaration"></span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <!-- Declaration preview -->
    <modal name="declaration_preview" transition="pop-out" :width="720" height="auto">
      <declarationPreview></declarationPreview>
    </modal>
  </div>
</template>

<script>
import declarationPreview from "./declaration_preview/declaration_preview.vue";

export default {
  name: "Health_declaration",
  components: {
    declarationPreview
  },
  data() {
    return {
      left_filter_hd: false
    };
  },
  methods: {
    table_filter_hd: function() {
      if (this.left_filter_hd == false) {
        this.left_filter_hd = true;
      } else {
        this.left_filter_hd = false;
      }
    },
    view_declaration: function() {
      this.$modal.show("declaration_preview");
    }
  }
};
</script>
